<template>
    <div class="p-6 bg-gray-100 min-h-screen">
      <h1 class="text-2xl font-bold mb-4">Claves Finales</h1>
  
      <div class="flex gap-4 mb-6">
        <button 
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.autorizado === true }"
          @click="toggleFilter('autorizado', true)">
          Mostrar Autorizados
        </button>
        <button 
          class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.autorizado === false }"
          @click="toggleFilter('autorizado', false)">
          Mostrar No Autorizados
        </button>
        <button 
          class="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.sin_video }"
          @click="toggleFilter('sin_video', true)">
          Sin Video Procesado
        </button>
        <button 
          class="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.sin_imagen }"
          @click="toggleFilter('sin_imagen', true)">
          Sin Imagen Procesada
        </button>
        <button 
          class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.con_imagen }"
          @click="toggleFilter('con_imagen', true)">
          Con Imagen Procesada
        </button>
        <button 
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.ordenar_por_fecha === 'asc' }"
          @click="toggleFilter('ordenar_por_fecha', 'asc')">
          Fecha Ascendente
        </button>
        <button 
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          :class="{ 'bg-gray-500 hover:bg-gray-600': filtros.ordenar_por_fecha === 'desc' }"
          @click="toggleFilter('ordenar_por_fecha', 'desc')">
          Fecha Descendente
        </button>
      </div>
  
      <div class="mb-4">
        <p class="text-gray-700">Registros visibles: <span class="font-bold">{{ registros.length }}</span></p>
      </div>
  
      <table class="table-auto w-full bg-white shadow rounded-lg">
        <thead class="bg-gray-200">
          <tr>
            <th class="px-4 py-2">ID</th>
            <th class="px-4 py-2">Clave Final</th>
            <th class="px-4 py-2">Imagen Base</th>
            <th class="px-4 py-2">Imagen Modificada</th>
            <th class="px-4 py-2">Video</th>
            <th class="px-4 py-2">Premio</th>
            <th class="px-4 py-2">Fecha de Creación</th>
            <th class="px-4 py-2">Autorizado</th>
            <th class="px-4 py-2">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="registro in registros" :key="registro.id_clave_final">
            <td class="border px-4 py-2">{{ registro.id_clave_final }}</td>
            <td class="border px-4 py-2">{{ registro.clave_final }}</td>
            <td class="border px-4 py-2">
              <a v-if="registro.imagen_base" :href="registro.imagen_base" class="text-blue-600 underline" target="_blank">
                Ver Imagen Base
              </a>
            </td>
            <td class="border px-4 py-2">
              <a v-if="registro.imagen_modificada" :href="registro.imagen_modificada" class="text-blue-600 underline" target="_blank">
                Ver Imagen Modificada
              </a>
            </td>
            <td class="border px-4 py-2">
              <a v-if="registro.video" :href="registro.video" class="text-blue-600 underline" target="_blank">
                Ver Video
              </a>
            </td>
            <td class="border px-4 py-2">
            <div>
                <p><strong>Token:</strong> {{ registro.premio.token_premio || registro.token_premio }}</p>
                <p><strong>Premio:</strong> {{ registro.premio.premio || 'N/A' }}</p>
                <p><strong>Activo:</strong> {{ registro.premio.activo === '1' ? 'Sí' : 'No' }}</p>
                <p v-if="registro.premio.utilizado"><strong>Utilizado:</strong> {{ registro.premio.utilizado }}</p>
            </div>
            </td>

            <td class="border px-4 py-2">{{ registro.creado }}</td>
            <td class="border px-4 py-2">{{ registro.autorizado === '1' ? 'Sí' : 'No' }}</td>
            <td class="border px-4 py-2">
              <button 
                v-if="registro.autorizado === '1'"
                class="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                @click="actualizarAutorizacion(registro.clave_final, false)">
                Desautorizar
              </button>
              <button 
                v-else
                class="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                @click="actualizarAutorizacion(registro.clave_final, true)">
                Autorizar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        registros: [],
        filtros: {
          autorizado: null,
          sin_video: false,
          sin_imagen: false,
          con_imagen: false,
          ordenar_por_fecha: null,
        },
      };
    },
    methods: {
      async fetchData() {
        try {
          const { data } = await axios.get('/api/claves-finales/obtener', {
            params: this.filtros,
          });
          this.registros = data.data;
        } catch (error) {
          console.error('Error al obtener los registros:', error);
        }
      },
      toggleFilter(filter, value) {
        // Reset mutually exclusive filters
        if (filter === 'sin_imagen' && value) this.filtros.con_imagen = false;
        if (filter === 'con_imagen' && value) this.filtros.sin_imagen = false;
  
        // Toggle the filter
        this.filtros[filter] = this.filtros[filter] === value ? null : value;
  
        // Fetch data after toggle
        this.fetchData();
      },
      async actualizarAutorizacion(claveFinal, autorizar) {
        try {
          await axios.post('/api/claves-finales/autorizar', {
            clave_final: claveFinal,
            autorizar,
          });
          this.fetchData();
        } catch (error) {
          console.error('Error al actualizar la autorización:', error);
        }
      },
    },
    mounted() {
      this.fetchData();
    },
  };
  </script>
  
  <style scoped>
  /* Estilos adicionales si son necesarios */
  </style>
  